import { createTeamsDarkTheme } from '../../utils/createTeamsDarkTheme';
import { brandTeams } from '../../global/brandColors';
import type { Theme } from '../../types';

export const teamsDarkTheme: Theme = createTeamsDarkTheme(brandTeams);
